export default __webpack_public_path__ + "static/media/img-0603-liechtenstein-full-face.a8f396a4.png";